import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TuiTablePaginationEvent } from '@taiga-ui/addon-table';

import { PREVIEW_ITEMS_COUNT, START_PAGE, START_PAGE_SIZE } from './constants';

@Component({
  selector: 'lp-statistics-table',
  templateUrl: './lp-statistics-table.component.html',
  styleUrls: ['./lp-statistics-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpStatisticsTableComponent {
  @Input() set data(value: Array<any> | undefined) {
    this.setData(value);
  }
  @Input() title = '';
  @Input() captions?: Record<string, string>;
  @Input() loading = true;
  @Input() unionId?: string;

  columns: Array<string> = [];

  items: Array<any> = [];

  showAll = false;
  readonly previewCount = PREVIEW_ITEMS_COUNT;

  showPagination = false;
  readonly pageSize$ = new BehaviorSubject(START_PAGE_SIZE);
  readonly currentPage$ = new BehaviorSubject(START_PAGE);

  getCaption(fieldName: string) {
    return this.captions?.[fieldName] ?? '';
  }

  // TODO: временное решение
  getItemValue(item: any, fieldName: string) {
    return item[fieldName];
  }

  onShowAll() {
    this.showAll = false;
  }

  onChangePagination({ page, size }: TuiTablePaginationEvent): void {
    this.currentPage$.next(page);
    this.pageSize$.next(size);
  }

  private setData(value?: Array<any>) {
    if (!value) {
      return;
    }

    this.columns = value.length ? this.getColumns(value[0]) : [];
    this.items = value;
    this.showAll = this.items.length > this.previewCount;
    this.showPagination = this.items.length > START_PAGE_SIZE;
  }

  private getColumns(value: any) {
    return Object.keys(value).filter(column => (this.captions ? Object.keys(this.captions).includes(column) : false));
  }
}
